import { isAxiosError } from "axios";
import { useMutation } from "@tanstack/react-query";
import AuthAPI from "../../api/auth";
import Toast from "../../Component/toast-alert";

export function useGetGoogleAuthUrl() {
  return useMutation({
    mutationFn: async authType => await AuthAPI.getAuthUrl(authType),
    onError: error => {
      if (isAxiosError(error)) {
        if (error.response.status === 404) {
          Toast.fire({
            icon: "error",
            title: "A user for this email could not be found"
          });
        } else if (error.response.status === 401) {
          Toast.fire({
            icon: "error",
            title: "Invalid password, please try again"
          });
        } else if (error.response.status === 500) {
          Toast.fire({
            icon: "error",
            title: "Internal server Error"
          });
        } else {
          Toast.fire({
            icon: "error",
            title: "Something went wrong"
          });
        }
      }
    }
  });
}
